import { IObservable, Observable } from '@1js/oil-externals/rx';

import { Learnings } from '../models/learning.model';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';

export class LearningSearchSuggestionProvider extends BaseSuggestionProvider {

    public static learnings: Learnings;
    public static shouldShowLearningSuggestions: boolean;

    public createStream(searchText: string): IObservable<any> {

        const searchResults = LearningSearchSuggestionProvider.learnings.getLearningList(LearningSearchSuggestionProvider.currentRoute.app);
        const randomResultNumber = Math.floor(Math.random() * searchResults.length);

        if (searchText?.trim() === '') {
            if (LearningSearchSuggestionProvider.shouldShowLearningSuggestions === undefined) {
                LearningSearchSuggestionProvider.shouldShowLearningSuggestions = this.shouldShowLearningSuggestions();
            }

            if ( LearningSearchSuggestionProvider.shouldShowLearningSuggestions) {
                return Observable.fromArray([
                    {
                        ariaLabel: LearningSearchSuggestionProvider.searchConfigService.config.resources.SearchSuggestionLearningAriaLabel,
                        isPwa: LearningSearchSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                        isDarkMode: LearningSearchSuggestionProvider.isDarkMode,
                        onClick: searchResults[randomResultNumber].onClick,
                        puid: LearningSearchSuggestionProvider.clientStartupConfigService.config.puid,
                        searchInstrumentationService: LearningSearchSuggestionProvider.searchInstrumentationService,
                        shellShim: LearningSearchSuggestionProvider.shellShim,
                        title: searchResults[randomResultNumber].displayText,
                        hideLearningSuggestions: this.hideLearningSuggestions
                    }
                ]);
            }
        }

        return Observable.empty();
    }

    public getId(): string {
        return 'learning';
    }

    public hideLearningSuggestions() {
        LearningSearchSuggestionProvider.shouldShowLearningSuggestions = false;
    }

    private shouldShowLearningSuggestions(): boolean {
        const learningStateObject = localStorage.getItem('OfficeDotComConsumerLearningStateObject');

        if (learningStateObject !== null && (JSON.parse(learningStateObject) as Array<string>).includes(LearningSearchSuggestionProvider.clientStartupConfigService.config.puid)) {
            return false;
        } else {
            return true;
        }
    }
}
